import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
// import { withTranslation } from 'react-i18next';
// import i18n from 'i18next';
import { apis } from '../../api/index.js';
import './barCharts.css';
import { Form, Checkbox, Button, message } from 'antd';
import qs from 'query-string';

class ImageQC extends Component {
  static propTypes = {
    objectUid: PropTypes.string,
    applicationInfo: PropTypes.object,
    thumbIndex: PropTypes.number,
    followupList: PropTypes.array,
  };

  constructor(props) {
    super(props);
    this.state = {
      value: [],
      disabled: false,
      options: [
        { label: '部位关键点没包全', value: '-1', disabled: false },
        { label: '曝光不足', value: '-2', disabled: false },
        { label: '曝光过度', value: '-3', disabled: false },
        { label: '体外异物伪影', value: '-4', disabled: false },
        { label: '图像模糊', value: '-5', disabled: false },
        { label: '正常影像', value: '1', disabled: false },
      ],
      dcmQcCodes: null,
      currentInfo: {},
    };
  }

  componentDidUpdate(prevProps) {
    const { applicationInfo, thumbIndex, followupList } = this.props;

    const ishistory = qs.parse(window.location.search).ishistory;
    if (
      ishistory &&
      (followupList !== prevProps.followupList ||
        thumbIndex !== prevProps.thumbIndex)
    ) {
      const info = followupList[thumbIndex] || {};
      this.setOptionState(info);
    } else if (
      applicationInfo !== prevProps.applicationInfo ||
      thumbIndex !== prevProps.thumbIndex
    ) {
      const { subVos = [] } = applicationInfo;
      const selected = subVos.filter(item => item.selectFlag);
      const info = selected[thumbIndex] || {};
      this.setOptionState(info);
    }
  }

  setOptionState = info => {
    const { options } = this.state;
    const { dcmQcCodes } = info;
    let roleInfo = window.store.getState().api.user.info.operationAuths || '';
    roleInfo = roleInfo.split(',');
    if (roleInfo.includes('M') && !dcmQcCodes) {
      options.forEach(item => (item.disabled = false));
      this.setState({ disabled: false, value: [], options, currentInfo: info });
    } else {
      this.setState({
        disabled: true,
        value: dcmQcCodes ? dcmQcCodes.split(',') : [],
        currentInfo: info,
      });
    }
  };

  componentDidMount() {}
  onChange = value => {
    const { options } = this.state;
    this.setState({ value });
    if (value.includes('1')) {
      options.forEach(item => {
        if (item.value === '1') item.disabled = false;
        else item.disabled = true;
      });
    } else if (value.length > 0) {
      options.forEach(item => {
        if (item.value === '1') item.disabled = true;
        else item.disabled = false;
      });
    } else {
      options.forEach(item => (item.disabled = false));
    }
    this.setState({ options });
  };
  onSubmit = () => {
    const { value, currentInfo } = this.state;
    if (value.length === 0) {
      message.warning('请选择至少一条影像质量评价');
      return;
    }
    const { dicomDrId } = currentInfo;
    const post = {
      dicomDrId,
      qcCode: value.join(','), // 质量评价选项
    };
    apis.updateDcmQc(post).then(res => {
      if (res.code === '0') {
        message.success('提交成功');
        this.setState({ disabled: true });

        const ishistory = qs.parse(window.location.search).ishistory;
        const { followupList, applicationInfo } = this.props;
        if (ishistory) {
          followupList.forEach(item => {
            if (item.dicomDrId === dicomDrId) item.dcmQcCodes = value.join(',');
          });
        } else {
          applicationInfo.subVos.forEach(item => {
            if (item.dicomDrId === dicomDrId) item.dcmQcCodes = value.join(',');
          });
        }
      } else message.error(res.message);
    });
  };
  render() {
    const { options, value, disabled } = this.state;
    return (
      <div className="report-img-qc">
        <div className="tit">影像质量评价</div>
        <div className="cnt">
          <Checkbox.Group
            options={options}
            value={value}
            onChange={this.onChange}
            disabled={disabled}
          />
        </div>
        {!disabled && (
          <div className="sub">
            <Button type="primary" size="large" onClick={this.onSubmit}>
              提交评价
            </Button>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(Form.create()(ImageQC));
